export default __webpack_public_path__ + "static/media/menu.b9966f9c.svg";